import { query } from "./strapi";

export async function getOrderByGeneratedId(
  email: string,
  generatedOrderId: string
) {
  try {
    const response = await query(
      `orders/lookup?email=${email}&generatedOrderId=${generatedOrderId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response; // Ensure the entire response object is returned
  } catch (err) {
    console.error("❌ Error fetching order:", err);
    throw err;
  }
}
